import { render, staticRenderFns } from "./FichaDetallePublico.vue?vue&type=template&id=2ccfd392&scoped=true"
import script from "./FichaDetallePublico.vue?vue&type=script&lang=js"
export * from "./FichaDetallePublico.vue?vue&type=script&lang=js"
import style0 from "./FichaDetallePublico.vue?vue&type=style&index=0&id=2ccfd392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccfd392",
  null
  
)

export default component.exports